import {
  Route,
  ServiceBike,
  ServiceBikeWithLastService,
  UpdateServiceBike,
  populateRoute,
} from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"
import { request } from "../api"
import jobQueries from "./job-queries"
import properInspectionQueries from "./proper-inspection-queries"
import receiptQueries from "./receipt-queries"

async function fetchBikes(
  storeId: string,
  phone?: string,
  email?: string,
  jobId?: string,
): Promise<ServiceBikeWithLastService[]> {
  return await request({
    url: populateRoute(Route.SERVICE_BIKE__FIND_BY_CUSTOMER, storeId),
    method: "GET",
    params: {
      phone,
      email,
      jobId,
    },
  })
}

async function updateBike(
  jobId: string,
  bike: UpdateServiceBike,
): Promise<ServiceBike> {
  return await request({
    url: populateRoute(Route.SERVICE_BIKE__UPDATE, jobId),
    method: "PATCH",
    data: bike,
  })
}

const bikeQueries = {
  all: () => ["bike"],
  list: (storeId: string, phone?: string, email?: string, jobId?: string) =>
    queryOptions({
      queryKey: [...bikeQueries.all(), storeId, phone, email, jobId],
      queryFn: () => fetchBikes(storeId, phone, email, jobId),
    }),
}

export function useUpdateBikeMutation(jobId: string) {
  const queryClient = useQueryClient()
  const router = useRouter()

  return useMutation({
    mutationFn: (bike: UpdateServiceBike) => updateBike(jobId, bike),
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries(jobQueries.detail(jobId)),
        queryClient.invalidateQueries(properInspectionQueries.detail(jobId)),
        queryClient.invalidateQueries(receiptQueries.detail(jobId)),
        queryClient.invalidateQueries({ queryKey: bikeQueries.all() }),
      ])
      router.invalidate()
    },
  })
}

export default bikeQueries
